import lightGallery from 'lightgallery';

document.addEventListener("DOMContentLoaded", function () {
    let lightgalleries = document.querySelectorAll('.lightgallery');
    lightgalleries.forEach(function (gallery) {
        lightGallery(gallery, {
            licenseKey: 'E31030A8-E8F2-489C-B0B7-443C2D887A9F',
            selector: 'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".webp"], a[href$=".avif"]',
            getCaptionFromTitleOrAlt: false
        });
    });
});